import React from "react";

export default ({ className, hover, checked }) => { 
    const inactiveColor = '#d9e0e8';
    const activeColor = '#3b7ed5';
    return <div className={className}>
        <svg width="14px" height="14px" viewBox="0 0 14 12" version="1.1" xmlns="http://www.w3.org/2000/svg" >
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-106.000000, -283.000000)" >
                <g transform="translate(90.000000, 267.000000)" >
                    <g transform="translate(16.000000, 16.000000)">
                        <rect
                            stroke={hover || checked ? activeColor : inactiveColor}
                            x="0.5"
                            y="0.5"
                            width="11"
                            height="11"
                            rx="2"
                        />
                        {checked && (
                            <g>
                                <path
                                    d="M11.5,0.968871126 L11.5,5"
                                    stroke="#FFFFFF"
                                    strokeWidth="4"
                                />
                                <polyline
                                    stroke="#3B7ED5"
                                    points="2 4.43024783 5.73024516 8 12 2"
                                />
                            </g>
                        )}
                    </g>
                </g>
            </g>
        </svg>
    </div>
 };
